import { useMutation, useQueryClient } from '@tanstack/react-query';
import { attachUsersToGroup } from '../services/security-groups';
import type { AttachUsersPayload } from '../types/security-admin.types';

export function useAttachUsersMutation(groupId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: AttachUsersPayload) => attachUsersToGroup(groupId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['security-group', groupId, 'users'] });
      queryClient.invalidateQueries({ queryKey: ['security-group', groupId] });
      queryClient.invalidateQueries({ queryKey: ['security-groups'] });
      queryClient.invalidateQueries({ queryKey: ['security-group', groupId, 'attachable-users'] });
    },
  });
}
